import {Type} from '@github-ui/react-query-persister/typebox'
import {Compile} from '@github-ui/react-query-persister/typebox/compile'

import {LinkedPullRequestsFieldSchema, StackedPullRequestsFieldSchema} from './board-payload'

/**
 * The deferred fields this client knows. Others are allowed, so a client deployed before the
 * server defers another field keeps working.
 */
const DeferredFieldsSchema = Type.Object({
  'linked-pull-requests': Type.Optional(LinkedPullRequestsFieldSchema),
  'stacked-pull-requests': Type.Optional(StackedPullRequestsFieldSchema),
})
export type BoardDeferredFields = Type.Static<typeof DeferredFieldsSchema>

const DeferredItemSchema = Type.Object({
  globalId: Type.String(),
  type: Type.Union([Type.Literal('issue'), Type.Literal('pull_request')]),
  /**
   * Every deferred field that applies to this item's type. A field absent here was not
   * delivered; an item the request named and the viewer cannot read is absent from `items`.
   */
  fields: DeferredFieldsSchema,
})
export type BoardDeferredItem = Type.Static<typeof DeferredItemSchema>

/** The deferred field values of cards a board already drew, from `board-deferred?ids=`. */
const DeferredPayloadSchema = Type.Object({
  items: Type.Array(DeferredItemSchema),
})
export type BoardDeferredPayload = Type.Static<typeof DeferredPayloadSchema>

const boardDeferredPayloadValidator = Compile(DeferredPayloadSchema)

export function isBoardDeferredPayload(value: unknown): value is BoardDeferredPayload {
  return boardDeferredPayloadValidator.Check(value)
}
